<template>
  <v-text-field v-if="required" v-model="value" @input="sync" :label="label" :readonly="readonly" :placeholder="label" :rules="rules" />
  <input v-else type="hidden" v-model="value" />
</template>

<script>
import DefaultField from './default'

export default {
  mixins: [DefaultField],
  props: {
    required: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    value: 'award field'
  }),
  methods: {
    init () {
      this.value = this.model || ''
      this.sync()
    },
    normalize () {
      let value = '' + this.value
      this.value = value.replace(',', '.')
      let norm = parseFloat(this.value)
      if (isNaN(norm)) {
        norm = ''
      }
      this.value = norm
    }
  }
}
</script>
